import "../frontend/index"



// WEBPACK FOOTER //
// ./app/webpack/packs/frontend.js